import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { theme } from "./muiStyled";
import { Input } from "./styled";
import Tooltip from "@material-ui/core/Tooltip";
import { MuiThemeProvider } from "@material-ui/core/styles";

const GenericInput = ({ name, value, onChange, onBlur, checked, disabled, errorMessage }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState();

  const getError = () => {
    setError(!checked);
    return error;
  };

  const setValue = () => {
    getError();
    dispatch(onBlur(value));
  };

  useEffect(() => {
    getError();
  }, [checked]);

  useEffect(() => {
    setError(false);
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <Tooltip title={error ? errorMessage : ""}>
        <Input
          error={error}
          autoComplete={"off"}
          id="outlined-adornment-password"
          name={name}
          value={value}
          onChange={(e) => dispatch(onChange(e.target.name, e.target.value))}
          onBlur={() => setValue()}
          disabled={disabled}
          disableFocusListener={false}
        />
      </Tooltip>
    </MuiThemeProvider>
  );
};

export default GenericInput;
